import { Routes } from '@angular/router';
import { AuthGuard } from './core/guards/auth.guard';
import { AppComponent } from './app.component';
import { CallbackComponent } from './pages/callback/callback.component';
import { provideStates } from '@ngxs/store';
import { AppState } from '@store/app/app.state';
import { PageNotFoundComponent } from './pages/page-not-found/page-not-found.component';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'station',
    pathMatch: 'full',
  },
  {
    path: 'station',
    loadChildren: () => import('./pages/station-dashboard/station-dashboard.routes').then(m => m.dashboardRoutes),
    canActivate: [AuthGuard]
  },
  {
    path: 'consultation',
    loadChildren: () => import('./pages/consultation/consultation.routes').then(m => m.consultationRoutes),
    canActivate: [AuthGuard]
  },
  {
    path: '',
    component: AppComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'auth-callback',
    component: CallbackComponent
  },
  {
    path: 'signout-callback',
    component: CallbackComponent
  },
  {
    path: 'page-not-found',
    component: PageNotFoundComponent
  }

];
